import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter'
})

export class FilterPipe implements PipeTransform {
    //transform(items: any[], searchText: string): any[] {
    //    if (!items) return [];
    //    if (!searchText) return items;
    //    searchText = searchText.toLowerCase();
    //    return items.filter(it => {
    //        return it.toLowerCase().includes(searchText);
    //    });
    //}
  transform(value: any, input: string, trigger: any) {
        if (input) {
           //console.log(value)
            //console.log(value.FN.toString() + " : " + value.UN.toString() + " : " + value.LN.toString() + " : "  + input)
            input = input.toLowerCase().trim();

            return value.filter(function (obj: any) {
               // console.log("this: ")
                //console.log(obj
              if (input == "checked:true") {
                if (obj.isChecked == true) {
                  return obj;
                }
              }
              else {
                if ((obj.fullname.toLowerCase().indexOf(input) > -1) || (obj.username.toLowerCase().indexOf(input) > -1)) {
                    return obj
                } }
               // return obj.FN.toLowerCase().indexOf(input) > -1;
            })
        }
        //console.log("this2: ")
        //console.log(value )
        return value;
    }
}
